import { render } from "./Laws.vue?vue&type=template&id=79de9029"
import script from "./Laws.vue?vue&type=script&lang=js"
export * from "./Laws.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__